import { render, staticRenderFns } from "./BPInstanceImage.vue?vue&type=template&id=546ad647&"
import script from "./BPInstanceImage.vue?vue&type=script&lang=js&"
export * from "./BPInstanceImage.vue?vue&type=script&lang=js&"
import style0 from "./BPInstanceImage.vue?vue&type=style&index=0&id=546ad647&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports